export interface ResponseModel <T> {
    data: T,
}

export interface Pagination {
    next_offset: number,
    total_count: number,
} 

export interface ListResponseModel <T> {
    data: T[],
    pagination: Pagination
}

class Error {
    field: string;
    message: string;
}

export class ErrorResponseModel {
    __v: string;
    code: number;
    errors: Error[];
    status: number;
    message: string;

    public constructor(data?: any) {
        if (data) {
            Object.assign(this , data);
        }
    }
    
    public convertToHash() {
        let errorFields = {};
        this.errors.forEach((err) => {
            errorFields[err.field] = err.message;
        });
        
        return errorFields;
    }
} 


// WEBPACK FOOTER //
// ./src/app/models/response/response.model.ts